// @flow
import React from 'react'
import VideoPlayer from '../videoPlayer/VideoPlayer'
import Chart from '../chart/Chart'

import { State } from '../../types/types'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import './styles.scss'
import UserFeedback from 'components/vote/Vote'
import { calculateScore } from 'components/main/helpers';

type Props = {
  number: number,
  data: State,
  name: string,
  handleVote: Function
}

export default function ChallengeEntry(props: Props) {
  const staticData = props.data.static.candidates.candidates[props.name]
  const dynamicData = props.data.dynamic[props.name]

  const challenge = `c${props.number}`

  return (
    <>
      <div className='ui text container challenge-entry'>
        <VideoPlayer
            trackingID={props.name}
            source={staticData.entries[challenge]['video']}
            poster={staticData.entries[challenge]['poster']}
        />
      </div>
      <div className='ui text container'>
        <h3 className='quote'>
          <span>
            <img
              src={staticData.image}
              alt={`Bild von ${staticData.fullName}`}
              className='ui circular mini avatar image'
            />
          </span>
          <span>{staticData.fullName}</span>
        </h3>
        <hr className='quote-divider' />
        <div className='quote label small'>
          <span className='quote label small'>{staticData.party}</span>
        </div>
      </div>
      <div className='ui text container'>
        <Chart
          trackingID='01 - Adam Lawler'
          shortText={`<p>${staticData.entries[challenge]['longText']}</p>`}
          descriptionText=''
          longText={`<p><span className='quote-hint'>«</span>${
            staticData.entries[challenge]['videoDescription']
            }<span className='quote-hint'>»</span></p>`}
        />
        <UserFeedback
          average={
            calculateScore(dynamicData['data'][challenge].v, dynamicData['data'][challenge].p, staticData.entries[challenge]['stars'])
          }
          voteHandler={props.handleVote}
          challenge={challenge}
          name={staticData.name}
          juryText={staticData.entries[challenge]['verdict']}
          juryStars={staticData.entries[challenge]['stars']}
          questions={['Wie bewerten Sie diesen Beitrag?']}
        />
        <hr className='quote-divider' />
        <p className='spacer'>&nbsp;</p>
      </div>
    </>
  )
}
